"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsentSearchResult = exports.ConsentSearchPerson = exports.ConsentSearchLead = exports.ADVERTISER_FACING_CHANNELS = exports.CONSENT_IDENTIFIER_TYPES = void 0;
var collect_model_1 = require("./collect.model");
exports.CONSENT_IDENTIFIER_TYPES = [
    'email',
    'phone'
];
exports.ADVERTISER_FACING_CHANNELS = [
    'email',
    'sms',
    'phone'
];
var NO_CONSENT = {
    status: 'none',
    expiresAt: null,
    withdrawnAt: null
};
var ConsentSearchLead = (function () {
    function ConsentSearchLead(data) {
        this.collect = new collect_model_1.Collect(data.lead);
        this.sentAt = data.sentAt || null;
        this.sendingConsents = data.sendingConsents || null;
    }
    ConsentSearchLead.prototype.sendingStateFor = function (advertiserId, channel) {
        var consent = (this.sendingConsents || []).find(function (each) { return each.advertiserId === advertiserId; });
        return (consent && consent.channels[channel]) || NO_CONSENT;
    };
    return ConsentSearchLead;
}());
exports.ConsentSearchLead = ConsentSearchLead;
var ConsentSearchPerson = (function () {
    function ConsentSearchPerson(data) {
        this.consents = data.consents || [];
        this.leads = (data.leads || []).map(function (lead) { return new ConsentSearchLead(lead); });
    }
    ConsentSearchPerson.prototype.stateFor = function (advertiserId, channel) {
        var consent = this.consents.find(function (advertiserConsent) { return advertiserConsent.advertiserId === advertiserId; });
        return (consent && consent.channels[channel]) || NO_CONSENT;
    };
    return ConsentSearchPerson;
}());
exports.ConsentSearchPerson = ConsentSearchPerson;
var ConsentSearchResult = (function () {
    function ConsentSearchResult(data) {
        this.identifierType = data.identifierType;
        this.advertisers = data.advertisers || [];
        this.people = (data.people || []).map(function (person) { return new ConsentSearchPerson(person); });
    }
    return ConsentSearchResult;
}());
exports.ConsentSearchResult = ConsentSearchResult;
